import { cognitoConfig } from './cognitoConfig';
import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';

const region = cognitoConfig.userPoolId.split('_')[0] || 'us-east-1';

export const cognitoClient = new CognitoIdentityProviderClient({
  region,
});

export { cognitoConfig };
